/**
 * React Query mutation hook for topping up user balance
 */

import { useMutation, useQueryClient } from '@tanstack/react-query'
import { v1UsersApi, TopUpRequest, TopUpResponse } from '../api'
import { toast } from 'sonner'

interface TopUpVariables extends TopUpRequest {
  userId: string
}

export function useTopUp() {
  const queryClient = useQueryClient()

  return useMutation<TopUpResponse, Error, TopUpVariables>({
    mutationFn: ({ userId, amount }: TopUpVariables) =>
      v1UsersApi.topUpBalance(userId, { amount }),

    onSuccess: (data) => {
      toast.success(
        `Successfully added ${data.amount_added} tokens to ${data.user_email}`,
        {
          description: `New balance: ${data.new_balance} tokens`
        }
      )

      // Invalidate users list and specific user queries
      queryClient.invalidateQueries({ queryKey: ['v1', 'users'] })
    },

    onError: (error: any) => {
      const message = error.response?.data?.detail || error.message || 'Failed to top up balance'
      toast.error('Top-up failed', {
        description: message
      })
    }
  })
}
